<template>
  <v-row no-gutters>
    <v-col cols="12" class="pa-2">      
      <v-row class="mb-4" justify="start">
        
        <!-- گزینه بدون لوگو (حذف لوگو) -->
        <v-col cols="auto" class="pa-1">
          <v-card 
            class="pattern pa-2 cursor-pointer d-flex justify-center align-center"
            :class="{ 'selected': !options.optionlogo || options.optionlogo === 'none' }"
            @click="selectLogo('none')"
            width="53"
            height="53"
            elevation="5"
            flat
          >
            <!-- تغییر رنگ آیکون به سفید در حالت انتخاب شده -->
            <v-icon :color="(!options.optionlogo || options.optionlogo === 'none') ? 'white' : 'grey darken-1'">
              mdi-cancel
            </v-icon>
          </v-card>
        </v-col>

        <!-- لیست لوگوها -->
        <v-col 
          cols="auto" 
          class="pa-1"
          v-for="(item, index) in allLogos" 
          :key="index"
        >
          <v-card 
            class="pattern pa-2 cursor-pointer d-flex justify-center align-center"
            :class="{ 'selected': options.optionlogo === item.value }"
            @click="selectLogo(item.value)"
            width="53"
            height="53"
            elevation="5"
            flat
          >
            <v-img 
              :src="item.img" 
              contain 
              width="100%" 
              height="100%"
            ></v-img>
          </v-card>
        </v-col>
      </v-row>

      <!-- دکمه آپلود لوگوی جدید -->
      <v-file-input
        accept="image/png, image/jpeg, image/svg+xml"
        :label="'آپلود لوگوی دلخواه'"
        outlined
        dense
        prepend-icon=""
        prepend-inner-icon="mdi-camera"
        @change="handleLogoUpload"
        clearable
      ></v-file-input>

      <div class="text-caption grey--text mb-2">{{ 'سایز لوگو' }}: {{ options.logo_size }}</div>
      <v-slider
        v-model="options.logo_size"
        min="10"
        max="150"
        @change="$emit('update', true)"
      ></v-slider>

      <v-switch
        v-model="options.no_logo_bg"
        true-value="on"
        false-value="off"
        :label="'حذف پس‌زمینه کیوآر زیر لوگو'"
        @change="$emit('update', true)"
      ></v-switch>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "qrCodeLogoAdv",
  props: {
    value: Object,
    designObject: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      customLogos: [] // نگهداری لوگوهای آپلود شده توسط کاربر
    };
  },
  computed: {
    options: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
    // ترکیب لیست لوگوهای API و لوگوهای شخصی کاربر
    allLogos() {
      return [...this.designObject, ...this.customLogos];
    }
  },
  methods: {
    selectLogo(value) {
      this.options.optionlogo = value;
      this.$emit('update', true);
    },
    handleLogoUpload(file) {
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Image = e.target.result;
        
        // اضافه کردن به لیست کاستوم
        this.customLogos.push({
          value: base64Image, // مقدار ارسالی به API
          img: base64Image    // مقدار نمایش در پیش‌نمایش گالری
        });

        this.selectLogo(base64Image);
      };
      
      reader.readAsDataURL(file);
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.pattern {
  border: 1px solid #e0e0e0; 
  transition: all 0.3s ease;
  background-color: transparent;
}

.pattern:hover {
  border: 1px solid #413199 !important;
  border-radius: 6px;
  background-color: #413199 !important;
  box-shadow: 0 -8px 6px rgba(25, 25, 26, 0.2), 0px 8px 6px rgba(25, 25, 26, 0.2) !important;
}

.pattern.selected {
  border: 1px solid #001554 !important;
  border-radius: 6px;
  background-color: #001554 !important;
  box-shadow: 0 10px 15px #00155423, 0px -10px 15px #00155423 !important;
}
</style>
